<template>
  <div>
    <div class="fe-text-heading-s fe-mb-xs">
      {{ averageRating }}
    </div>
    <div class="fe-mb-xxs lg:fe-mb-xs">
      <StarRating
        :readOnly="true"
        :initialRating="averageRating"
        size="s"
        :partialSupport="true"
      />
    </div>
    <div class="fe-text-body-xxs lg:fe-text-body-s fe-text-primary-grey-80">
      {{ totalRatingCountText }}
    </div>
  </div>
</template>

<script>
  import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"
  import { pluralize } from "@/utils/utils"

  export default {
    components: { StarRating },
    name: "RatingStats",
    inject: ["globalState"],
    computed: {
      averageRating() {
        return this.globalState.avgRating || 0
      },
      totalRatingCountText() {
        const ratingsCount = this.globalState.ratingsCount || 0

        return `${ratingsCount} ${pluralize("rating", ratingsCount)}`
      },
    },
  }
</script>
